import { Schema } from "@/modules/FormTemplate/models/Schema";
import { FullSchema } from "../../../shared/models/FullSchema";

export class GroupFullSchema {
  allOf!: FullSchema[];
  type!: string;
  "x-display"?: string;
  properties?: { [name: string]: Schema };
  "x-props"?: { [name: string]: Schema };
  readOnly?: string | boolean;
}
